export default __webpack_public_path__ + "static/media/animation-key.a29c3d50.gif";